export interface SpecialTopic {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  intro: string;
  filmIds: string[];
  reason: string;
  relatedIds: string[];
  updatedAt: string;
}

export const specials: SpecialTopic[] = [
  {
    id: "s001",
    title: "西行之路：公路与远方影像志",
    subtitle: "在路上，遇见另一种人生",
    cover: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20landscape%20of%20an%20empty%20desert%20highway%20stretching%20toward%20a%20warm%20orange%20sunset%20horizon%2C%20distant%20mountains%2C%20long%20shadows%2C%20dust%20in%20the%20air%2C%20muted%20amber%20and%20earthy%20tones%2C%20wandering%20solitary%20mood%2C%20high%20detail%20cinematic%20photography&width=1600&height=900&seq=special-s001&orientation=landscape",
    intro: "公路片从来不只是在讲一段旅程，它讲的是人在离开熟悉之地后，如何重新认识自己。本专题选取平台内最具代表性的“在路上”作品，带你一起驶向远方。",
    filmIds: ["f001", "f010", "f012"],
    reason: "选择这组作品，是因为它们都把“移动”当作叙事的引擎。无论是穿越荒原的邮差、驶向星云的孤舟，还是潜入深海的小艇，主人公都在远离日常的过程中，被迫直面内心最真实的部分。远方不是目的地，而是一面照见自己的镜子。",
    relatedIds: ["s002"],
    updatedAt: "2024-10-10",
  },
  {
    id: "s002",
    title: "人间烟火：平凡生活的温柔底色",
    subtitle: "最打动人的，往往是日常",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cozy%20night%20scene%20of%20a%20small%20old%20alley%20with%20glowing%20orange%20string%20lights%2C%20steaming%20food%20stalls%2C%20soft%20bokeh%2C%20people%20gathering%20quietly%2C%20warm%20amber%20and%20cream%20tones%2C%20gentle%20intimate%20everyday%20mood%2C%20high%20detail%20cinematic%20photography&width=1600&height=900&seq=special-s002&orientation=landscape",
    intro: "没有惊天动地的转折，只有一顿饭、一盏灯、一次照面。本专题聚焦那些记录普通人生活的作品，它们把温柔藏在了最不起眼的细节里。",
    filmIds: ["f011", "f003", "f005"],
    reason: "这组作品共同证明了一件事：最动人的故事往往不需要宏大的背景。老巷里的炒摊、春运中的站台、樱花树下的约定，都是普通人认真活过的证据。它们提醒我们停下来，去看见被忽略的日常。",
    relatedIds: ["s001", "s003"],
    updatedAt: "2024-09-26",
  },
  {
    id: "s003",
    title: "迷雾之下：悬疑与真相的博弈",
    subtitle: "每个人都在隐藏什么",
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20dark%20mystery%20scene%20of%20an%20empty%20rainy%20city%20street%20at%20night%20with%20warm%20orange%20streetlight%20halos%20in%20thick%20fog%2C%20wet%20pavement%20reflections%2C%20lone%20figure%20walking%20away%2C%20moody%20tense%20suspense%20mood%2C%20high%20detail%20cinematic%20photography&width=1600&height=900&seq=special-s003&orientation=landscape",
    intro: "悬疑的魅力，不在于谜底有多惊人，而在于我们在追查真相的过程中，逐渐看清每个人心中的裂缝。本专题带你进入那些越接近真相越令人不安的故事。",
    filmIds: ["f002", "f004", "f009"],
    reason: "这组作品都提出了同一个问题：当真相比谎言更难承受时，人们会怎么选？路灯、信号、玻璃塔，这些看似客观的物证背后，藏着的是人最不愿被看见的动机。悬疑的外壳之下，是一颗颗复杂的人心。",
    relatedIds: ["s002"],
    updatedAt: "2024-09-15",
  },
];